export default __webpack_public_path__ + "static/media/GreekTableImg.7980cb30.jpg";